<template>
    <joy-spinner class="profile-creation-wizard__loader" />
</template>
<style lang="scss" scoped>
    .profile-creation-wizard {
        &__loader {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(3);
        }
    }
</style>
